var _excluded = ["children", "content"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { ModalContent as ModalContentSemantic } from 'semantic-ui-react';

/**
 * A modal can contain content.
 *
 * @param {any} props
 * @returns
 */
import { jsx as _jsx } from "react/jsx-runtime";
var ModalContent = function ModalContent(props) {
  var children = props.children,
    content = props.content,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (!_.isNil(children) || !_.isEmpty(children)) {
    return /*#__PURE__*/_jsx(ModalContentSemantic, Object.assign({}, rest, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(ModalContentSemantic, Object.assign({
    content: content
  }, rest));
};
ModalContent.handledProps = ["as", "children", "className", "content", "id", "image", "scrolling"];
ModalContent.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  /** Primary content. */
  children: PropTypes.node,
  /** Additional classes. */
  className: PropTypes.string,
  /** Shorthand for primary content. */
  content: PropTypes.node,
  /** Id */
  id: PropTypes.string,
  /** A modal can contain image content. */
  image: PropTypes.bool,
  /** A modal can use the entire size of the screen. */
  scrolling: PropTypes.bool
};
ModalContent.defaultProps = {
  scrolling: true
};
export default ModalContent;